import api from "../apiClient";

// Operations surface — the office screen's data source.
export const getOfficeReport = (params = {}) => api.get("/ops/office-report/", { params });
export const getPace = (params = {}) => api.get("/ops/pace/", { params });
